/** Index déclarés dans le backoffice Kameleoon (« Advanced Tools ») : ils ne peuvent pas être renumérotés ici. */
export enum KameleoonCustomDataIndexEnum {
  Lang = 0,
  VisitorId = 1,
  PartnerId = 2,
  PartnerName = 3,
  TrackId = 4,
  HelpsCount = 5,
  HelpsAmount = 6,
  CcoId = 7,
}
